import { SectionTitle as IntroductionTitle } from '@/components/CompanyOverview/components/Introduction/styled';
import { SectionTitle as ReportTitle } from '@/components/ReportSectionHeader/styled';
import { useSummary } from '@/hooks/useCompany';
import { CompanyReportSection, useSection } from '../../useSection';

export const SplitSectionTitle = ({
  title,
  isIntroduction,
  section,
}: {
  title: string;
  isIntroduction?: boolean;
  section: CompanyReportSection;
}) => {
  const { initialSection } = useSection();
  const summary = useSummary();
  const formattedTitle =
    (summary.status === 'success' &&
      section === initialSection &&
      `${summary.name} ${title}`) ||
    title;

  return (
    <>
      {isIntroduction ? (
        <IntroductionTitle as="h1">{formattedTitle}</IntroductionTitle>
      ) : (
        <ReportTitle as="h1">{formattedTitle}</ReportTitle>
      )}
    </>
  );
};
